/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ShieldOff = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M19.7 14a6.9 6.9 0 0 0 .3-2V5l-8-3-3.2 1.2" }],
    ["path", { d: "m2 2 20 20" }],
    ["path", { d: "M4.7 4.7 4 5v7c0 6 8 10 8 10a20.3 20.3 0 0 0 5.62-4.38" }]
  ]
];

export { ShieldOff as default };
//# sourceMappingURL=shield-off.js.map
